import { FormBase } from 'core/components';

export default class NikoPatientEligibilityStatusNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'eligibilityStatusNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.ELIGIBILITY_STATUS_NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.ELIGIBILITY_STATUS_NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}